import React from 'react';
import { IconButton } from '@material-ui/core';
import useStyles from './styles';

const MyIconButton = ({Icon}) => {
    const classes = useStyles();
    return (
        <IconButton className={classes.IconButton}>
            {Icon}
        </IconButton>
    )
}

export default MyIconButton
